import { Navigate, useLocation } from "react-router-dom";
import useAuthStore from "../../store/AuthStore";

const UserRoute = ({ element }) => {
  const location = useLocation();
  const { user } = useAuthStore();
  
  if (!user) {
    sessionStorage.setItem("redirectPath", location.pathname);
    return <Navigate to="/login" />;
  }

  if (user.isAdmin) {
    return <Navigate to="/admin" />;
  }
  return element;
};

export default UserRoute;
